export default "__VITE_ASSET__BnMuFr1p__"